const LeadCountsForListing = ({
    listingAlias = '',
    listingId = '',
    aliasEncoded = '',
    unreadCount = 0,
    notRepliedToCount = 0,
    totalConversationsCount = 0,
} = {}) => ({
    listingAlias: String(listingAlias),
    listingId: String(listingId),
    aliasEncoded: String(aliasEncoded),
    unreadCount: Number(unreadCount),
    notRepliedToCount: Number(notRepliedToCount),
    totalConversationsCount: Number(totalConversationsCount),
});

export default LeadCountsForListing;
